export default "__VITE_PUBLIC_ASSET__4bfdcdc8__"